import React, { useCallback } from 'react';
import { Box, FormControl, MenuItem, Select, TextField, Typography } from '@mui/material';
import sx, { RecurringCard } from '../RecurringItem.style';

function SelectWeekdays({ show, days, handleDaysChange, disabled }) {
    if (!show) return null;

    return (
        <Box>
            <Typography>Repeat on</Typography>
            <Box sx={(theme) => sx(theme).dayGrid}>
                {['Su', 'M', 'T', 'W', 'R', 'F', 'Sa'].map((day, d) => {
                    return (
                        <Box
                            sx={(theme) => ({
                                ...sx(theme).day,
                                ...(days.includes(d) ? sx(theme).daySelected : {}),
                            })}
                            onClick={() => {
                                if (!disabled) handleDaysChange(d);
                            }}
                        >
                            {day}
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}

function SelectMonthDays({ show, daysOfMonth, recurDayOfMonth, disabled, handleDayOfMonthChange }) {
    if (!show) return null;

    return (
        <Select sx={(theme) => sx(theme).topMargin} disabled={disabled} value={recurDayOfMonth} onChange={handleDayOfMonthChange} autoWidth>
            <MenuItem value={0}>Monthly on day #</MenuItem>
            {daysOfMonth.map((day) => (
                <MenuItem key={day} value={day}>
                    {day.toString()}
                </MenuItem>
            ))}
        </Select>
    );
}

export default function CustomOptionsCard({ item, setItem, disabled }) {
    if (item.frequency !== 0) return null;

    const pluralChar = item.customFrequency > 1 ? 's' : '';
    const daysOfMonth = Array.from({ length: 31 }, (_, i) => i + 1);

    const handleCustomFrequencyChange = (event) => {
        setItem({
            ...item,
            customFrequency: Math.max(1, Number(event.target.value)),
            frequency: 0,
        });
    };

    const handleDaysChange = useCallback((d) => {
        const days = [...item.days];
        const index = days.indexOf(d);
        if (index > -1) {
            if (days.length > 1) {
                days.splice(index, 1);
            }
        } else {
            days.push(d);
            days.sort();
        }
        setItem({
            ...item,
            days,
        });
    }, []);

    const handleUnitChange = (event) => {
        setItem({
            ...item,
            unit: event.target.value,
        });
    };

    const handleDayOfMonthChange = (event) => {
        setItem({
            ...item,
            recurDayOfMonth: event.target.value,
        });
    };

    return (
        <RecurringCard title="Custom Schedule">
            <FormControl sx={(theme) => sx(theme).formControl}>
                <Box>
                    <Box sx={(theme) => sx(theme).topMargin} display="flex">
                        <Typography display="flex" alignItems="center">
                            Repeat every
                        </Typography>
                        <TextField
                            sx={(theme) => sx(theme).daySelect}
                            placeholder="#"
                            type="number"
                            value={item.customFrequency}
                            onChange={handleCustomFrequencyChange}
                            // wrap
                        />
                        <Select sx={(theme) => sx(theme).unitSelect} disabled={disabled} value={item.unit} onChange={handleUnitChange}>
                            <MenuItem value={'minute'}>{`minute${pluralChar}`}</MenuItem>
                            <MenuItem value={'hour'}>{`hour${pluralChar}`}</MenuItem>
                            <MenuItem value={'day'}>{`day${pluralChar}`}</MenuItem>
                            <MenuItem value={'week'}>{`week${pluralChar}`}</MenuItem>
                            <MenuItem value={'month'}>{`month${pluralChar}`}</MenuItem>
                            <MenuItem value={'year'}>{`year${pluralChar}`}</MenuItem>
                        </Select>
                    </Box>
                </Box>
                <SelectWeekdays
                    show={item.unit === 'week'}
                    days={item.days}
                    handleDaysChange={handleDaysChange}
                    disabled={disabled}
                    // wrap
                />
                <SelectMonthDays
                    show={item.unit === 'month'}
                    daysOfMonth={daysOfMonth}
                    recurDayOfMonth={item.recurDayOfMonth}
                    handleDayOfMonthChange={handleDayOfMonthChange}
                    disabled={disabled}
                    // wrap
                />
            </FormControl>
        </RecurringCard>
    );
}
